import { Dashboard, Pages } from "@mui/icons-material";
import { IFeatures } from "../../utils/interfaces";
import { Home } from "./Home";
import { appType, currentFeatures } from "../../configs/Settings";
import VetProfessionalDashboard from "@/fluxvet/components/VetProfessionalDashboard";
import { useSessionContext } from "@/contexts/SessionContext";
import { useOrganizationContext } from "@/contexts/OrganizationContext";
import { isEcommerceOrganization } from "@/pages/ecommerce/helpers/isEcommerceOrganization";
import FluxVetDashboard from "@/fluxvet/pages/dashboard/FluxVetDashboard";

export function useHome() {
  const { access } = useSessionContext();
  const { organization } = useOrganizationContext();
  const isEcommerceProfessional =
    access.type === "professional" && isEcommerceOrganization(organization);

  const configs: IFeatures = {
    initial: !isEcommerceProfessional,
    active: currentFeatures.home && !isEcommerceProfessional,
    path: "/home",
    text: currentFeatures.defaultApp ? "Painel de controle" : "Dashboard",
    icon: currentFeatures.defaultApp ? Pages : Dashboard,

    sideMenu: !isEcommerceProfessional,
    sideMenuIndex: 0,

    component: () =>
      !currentFeatures.defaultApp && access.type === "patient" ? (
        <FluxVetDashboard />
      ) : (
        <Home />
      ),
  };

  return configs;
}
